<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- Dashboard Box -->

                        <div class="col-lg-12 col-md-12 col-xs-12 col-xl-12 margin-bottom-30">
                            <button class="button big gray block-mobile margin-bottom-10" v-bind:class="{'green': tab == 'relatorio-1'}" type="button" v-on:click="setTab('relatorio-1')">
                                <i class="material-icons">swap_horiz</i>
                                Estoque
                            </button>
                            <button class="button big gray block-mobile margin-bottom-10" v-bind:class="{'green': tab == 'relatorio-2'}" type="button" v-on:click="setTab('relatorio-2')">
                                <i class="material-icons">local_gas_station</i>
                                Vendas
                            </button>
                            <button class="button big gray block-mobile margin-bottom-10" v-bind:class="{'green': tab == 'relatorio-3'}" type="button" v-on:click="setTab('relatorio-3')">
                                <i class="material-icons">people</i>
                                Ordens de clientes
                            </button>
                            <button class="button big gray block-mobile margin-bottom-10" v-bind:class="{'green': tab == 'relatorio-4'}" type="button" v-on:click="setTab('relatorio-4')">
                                <i class="material-icons">local_drink</i>
                                Vendas de óleos
                            </button>                            
                        </div>

                        <div class="col-xl-12" v-show="tab == 'relatorio-1'">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get('relatorio-entrada-saida-estoque')">
                                <div class="row">
                                    <div class="col-lg-4 col-xs-12 col-xl-4 col-md-4" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                        <div class="submit-field">
                                            <h5>Selecione a filial:</h5>
                                            <select class="with-border" v-model="form.empresaCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-12 col-xl-4 col-md-4" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Selecione o local do estoque:</h5>
                                            <select class="with-border" v-model="form.estoqueCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in estoque.itens" v-if="item.empresaCod == form.empresaCod" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>       
                                    <div class="col-lg-3 col-xs-6 col-xl-3 col-md-3" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Mês:</h5>
                                            <select class="with-border" v-model="form.mes">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option value="1" selected>Janeiro</option>
                                                <option value="2" selected>Fevereiro</option>
                                                <option value="3" selected>Março</option>
                                                <option value="4" selected>Abril</option>
                                                <option value="5" selected>Maio</option>
                                                <option value="6" selected>Junho</option>
                                                <option value="7" selected>Julho</option>
                                                <option value="8" selected>Agosto</option>
                                                <option value="9" selected>Setembro</option>
                                                <option value="10" selected>Outubro</option>
                                                <option value="11" selected>Novembro</option>
                                                <option value="12" selected>Dezembro</option>
                                            </select>                                            
                                        </div>
                                    </div>                                                                      
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-2" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Ano:</h5>
                                            <input type="number" v-model="form.ano" class="with-border">
                                        </div>
                                    </div>                                                                        
                                    <!-- <div class="col-lg-12"></div> -->
                                    <div class="col-lg-4 col-md-4" v-bind:class="{'disabled': !form.empresaCod || !form.estoqueCod}">
                                        <div class="submit-field">
                                            <!-- <div class="hidden-xl hidden-lg hidden-sm margin-top-10"></div> -->
                                            <!-- <div class="hidden-xs hidden-md clearfix" v-if="$root.user.tipo == 'prestador'" style="margin-top: 32px;"></div> -->
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 32px;"></div>
                                            <div class="hidden-xs clearfix" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 32px;"></div>                                           
                                            <button class="button gray" type="submit">
                                                <i class="material-icons">refresh</i>
                                                Gerar relatório
                                            </button>                                         
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                             
                        </div>

                        <div class="col-xl-12" v-show="tab == 'relatorio-2'">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get('relatorio-vendas-clientes')">
                                <div class="row">
                                    <div class="col-lg-4 col-xs-12 col-xl-4 col-md-4" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                        <div class="submit-field">
                                            <h5>Selecione a filial:</h5>
                                            <select class="with-border" v-model="form.empresaCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-12 col-xl-4 col-md-4" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Selecione o local do estoque:</h5>
                                            <select class="with-border" v-model="form.estoqueCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in estoque.itens" v-if="item.empresaCod == form.empresaCod" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>                                     
                                    <div class="col-lg-3 col-xs-6 col-xl-3 col-md-3" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Mês:</h5>
                                            <select class="with-border" v-model="form.mes">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option value="1" selected>Janeiro</option>
                                                <option value="2" selected>Fevereiro</option>
                                                <option value="3" selected>Março</option>
                                                <option value="4" selected>Abril</option>
                                                <option value="5" selected>Maio</option>
                                                <option value="6" selected>Junho</option>
                                                <option value="7" selected>Julho</option>
                                                <option value="8" selected>Agosto</option>
                                                <option value="9" selected>Setembro</option>
                                                <option value="10" selected>Outubro</option>
                                                <option value="11" selected>Novembro</option>
                                                <option value="12" selected>Dezembro</option>
                                            </select>                                            
                                        </div>
                                    </div>    
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-2" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Ano:</h5>
                                            <input type="number" v-model="form.ano" class="with-border">
                                        </div>
                                    </div>                                                                        

                                    <div class="col-lg-4 col-md-4" v-bind:class="{'disabled': !form.empresaCod || !form.mes || !form.ano || !form.estoqueCod}">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 32px;"></div>
                                            <div class="hidden-xs clearfix" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 32px;"></div>
                                            <button class="button gray " type="submit">
                                                <i class="material-icons">refresh</i>
                                                Gerar relatório
                                            </button>                                         
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>

                        <div class="col-xl-12" v-show="tab == 'relatorio-3'">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get('relatorio-ordens-clientes')" novalidate="">
                                <div class="row">
                                    <div class="col-xl-6 col-xs-12 col-md-6 campo-cliente">
                                        <div class="submit-field margin-bottom-0">
                                            <h5>
                                                Cliente
                                            </h5>
                                        </div>
                                        <autocomplete ref="clienteNome" :search="searchAutocompleteCliente" placeholder="Pesquise o cliente aqui (nome, CNPJ..)" aria-label="Pesquise o cliente aqui (nome, CNPJ..)" :get-result-value="getResultAutocompleteCliente" @submit="submitAutocompleteCliente"></autocomplete>
                                    </div>

                                    <div class="col-lg-3 col-xs-12 col-xl-3 col-md-4" v-bind:class="{'disabled': !form.clienteCod}">
                                        <div class="submit-field">
                                            <h5>Do dia:</h5>
                                            <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.dataInicio" required="">                                          
                                        </div>
                                    </div>       

                                    <div class="col-lg-3 col-xs-12 col-xl-3 col-md-4" v-bind:class="{'disabled': !form.clienteCod}">
                                        <div class="submit-field">
                                            <h5>Até o dia:</h5>
                                            <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.dataFinal" required="">                                       
                                        </div>
                                    </div>                                           
                                                                                                         
                                    <!-- <div class="col-lg-12"></div> -->
                                    <div class="col-lg-4 col-md-4" v-bind:class="{'disabled': !form.clienteCod}">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10" style="margin-top: 32px;"></div>
                                            <div class="hidden-xs hidden-lg hidden-xl clearfix" style="margin-top: 32px;"></div>   
                                            <button class="button gray" type="submit">
                                                <i class="material-icons">refresh</i>
                                                Gerar relatório
                                            </button>                                         
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                             
                        </div>


                        <div class="col-xl-12" v-show="tab == 'relatorio-4'">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get('relatorio-vendas-oleos')">
                                <div class="row">
                                    <div class="col-lg-4 col-xs-12 col-xl-4 col-md-4" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                        <div class="submit-field">
                                            <h5>Selecione a filial:</h5>
                                            <select class="with-border" v-model="form.empresaCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>      
                                    <div class="col-lg-4 col-xs-12 col-xl-4 col-md-4" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Selecione o óleo:</h5>
                                            <select class="with-border" v-model="form.catalogoCod">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option v-for="item in catalogo.itens" v-if="item.estoque == 0" :value="item.cod">{{item.nome}}</option>
                                            </select>                                            
                                        </div>
                                    </div>                                                                   
                                    <div class="col-lg-3 col-xs-6 col-xl-3 col-md-3" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Mês:</h5>
                                            <select class="with-border" v-model="form.mes">
                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                <option value="1" selected>Janeiro</option>
                                                <option value="2" selected>Fevereiro</option>
                                                <option value="3" selected>Março</option>
                                                <option value="4" selected>Abril</option>
                                                <option value="5" selected>Maio</option>
                                                <option value="6" selected>Junho</option>
                                                <option value="7" selected>Julho</option>
                                                <option value="8" selected>Agosto</option>
                                                <option value="9" selected>Setembro</option>
                                                <option value="10" selected>Outubro</option>
                                                <option value="11" selected>Novembro</option>
                                                <option value="12" selected>Dezembro</option>
                                            </select>                                            
                                        </div>
                                    </div>    
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-2" v-bind:class="{'disabled': !form.empresaCod}">
                                        <div class="submit-field">
                                            <h5>Ano:</h5>
                                            <input type="number" v-model="form.ano" class="with-border">
                                        </div>
                                    </div>                                                                        

                                    <div class="col-lg-4 col-md-4" v-bind:class="{'disabled': !form.empresaCod || !form.catalogoCod || !form.mes || !form.ano}">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 32px;"></div>
                                            <div class="hidden-xs clearfix" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" style="margin-top: 32px;"></div>
                                            <button class="button gray " type="submit">
                                                <i class="material-icons">refresh</i>
                                                Gerar relatório
                                            </button>                                         
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>

                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Relatorios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    watch: {
        "form.empresaCod": function(val) {
            console.log("change >> form.empresaCod()", val);
            var self        = this;
            self.form.estoqueCod = "";
            self.$forceUpdate();
        },
        "tab": function(val) {
            console.log("change >> tab()", val);
            var self        = this;
            self.form.estoqueCod = "";
            self.$forceUpdate();
        }        
    },    
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  "relatorio-1",
            "data":                 {
                "itens":            []
            },
            "empresas":              {
                "itens":            []
            },
            "catalogo":             {
                "itens":            []
            },          
            "estoque":              {
                "itens":            []
            },                                    
            "loading": {
                "submit":           false
            },      
            "form": {
                "_cod":             self.$root.user.cod,
                "empresaCod":       "",
                "estoqueCod":       "",
                "catalogoCod":      "",
                "mes":              (new Date().getMonth()+1),
                "ano":              (new Date().getFullYear()),                
            },
        }
    },
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;

            // if (tab == "editar" || tab == "visualizar" || tab == "lista") {
            //     self.get();
            // }

            // if (tab == "historico") {
            //     self.getHistorico();
            // }            

        },   
        getEstoque: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoque",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "group":        false
                    }
                };

                axios.get("api/estoque.php", form)
                .then(response => {
                    
                    console.log("getEstoque() result", response.data);
                    self.estoque.itens  = response.data.result.itens;
                    resolve(response.data.result);

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },         
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },        
        getCatalogo: function() {
            var self        = this;
            console.log("getCatalogo()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "catalogo",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "catalogo"
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("getCatalogo() response", response);
                    self.catalogo       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCatalogo() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },                       
        get: function(tipo) {
            var self        = this;
            console.log("get()");
            self.data.itens = [];
            self.loaded     = false;
            self.form.tipo  = tipo;
            console.log("Form relatório:", self.form.tipo);
            var tipo = "_blank";
            if (window.cordova)  {
                tipo = "_system";
            }
            // window.open("http://localhost:8081" + "/relatorio.php?" + (new URLSearchParams(self.form).toString()), tipo);
            window.open(self.$root.config.url + "/relatorio.php?" + (new URLSearchParams(self.form).toString()), tipo);
        },
        getResultAutocompleteCliente: function(result) {
          return (result.razaoSocial ? result.razaoSocial : result.nome);
        },   
        submitAutocompleteCliente: function(obj) {
            console.log("Cliente:", obj)
            var self = this;
            self.form.clienteCod    = obj.cod;
            self.form.cliente       = obj;
            self.$forceUpdate();
        },
        searchAutocompleteCliente: function(val) {
            var self = this;
            return new Promise(function(resolve, reject) {

                if (self.requestAutocomplete) {
                    self.requestAutocomplete.cancel(); 
                }

                self.requestAutocomplete = axios.CancelToken.source();  
                
                var form = {
                    "db":               "clientes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1,
                        "autocomplete": true,
                        "pesquisa":     val
                    },
                    "cancelToken":      self.requestAutocomplete.token  
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    resolve(response.data.result.itens);
  
                })
                .catch(error => {
                    loading.hide();
                    reject(error);
                }); 

            });
        },  
        init: function() {
            var self = this;

            Promise.all([
                // self.get(),
                self.getEstoque(),
                self.getEmpresas(),
                self.getCatalogo(),
            ]).then(function() {
            
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });             
        }                       
    },
    created: function() {
        var self = this;

        loading.show();
        if (self.$root.user.tipo == "prestador") {
            self.form.empresaCod = self.$root.user.empresaCod;
        }
        var date                = new Date();
        var firstDay            = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay             = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        self.form.dataInicio    = firstDay.toISOString().split("T")[0];
        self.form.dataFinal     = lastDay.toISOString().split("T")[0];
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }      
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button.big.green {
        border-color: #30ab4a !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Relatorios.vue